<template>
  <div class="layouts-aplications-content" id="identidade-visual-aplicacoes" data-search-anchor>    
    <div class="layouts-aplications-wrapper">
      <h1 class="layout-aplications-title-span">{{ layoutAplicationsTitleSpan }}</h1>     
      <h1 class="layout-aplications-title">{{ layoutAplicationsTitle }}</h1>      
    </div>
    <div
      class="layouts-aplications-card-item"
      :style="{ backgroundImage: `url(${layoutAplicationsImageSrc})`}"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import LayoutPageMixin from '@/mixins/layout-page-mixin'
import { LayoutPageStore } from '@/store/visual-identity-page/layout-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class LayoutsPhotosSection extends Mixins(LayoutPageMixin) {
  layoutPageStore: PageStoreContract = getModule(LayoutPageStore, this.$store)

  get layoutAplicationsTitleSpan(): string {
    return this.getElementTitle(20, 0)
  }
  
  get layoutAplicationsTitle(): string {
    return this.getElementText(20, 0)
  } 

  get layoutAplicationsImageSrc(): string {
    return this.getElementMedia(20, 0)
  }

  async getLayoutPage(): Promise<void> {
    await this.layoutPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.layoutPageStore.isLoading) {
      await this.getLayoutPage()
    }
  }
}
</script>

<style lang="scss">
.layouts-aplications-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.layouts-aplications-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding: 6.25rem 0rem 2rem 0rem;
}

.layout-aplications-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.layout-aplications-title{
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.layouts-aplications-card-item {
  position: relative;   

  max-width: 1032px;
  width: 100%;
  height: 527px;
  margin-bottom: 2rem;

  background-repeat: no-repeat;
  background-size: contain;
}
</style>
